// removed by extract-text-webpack-plugin
module.exports = {"agentCard":"cz_cw","nav":"cz_c0"};


//////////////////
// WEBPACK FOOTER
// ./src/partials/brokerage-card/brokerage-card.module.scss
// module id = 1871
// module chunks = 0